import { colors, Grid } from "@mui/material";
import { OrderQueues } from "helpers/enums";
import { useContext } from "react";
import { Queues, Dashboard, Filters, Results } from "./components";
import { ordersContext } from "./OrdersContext";

let Orders = () => {
    let { search } = useContext(ordersContext);

    return (
        <Grid container>
            <Grid item xs={4} sm={3} md={2} style={{ borderRight: `1px solid ${colors.grey[300]}` }}>
                <Queues />
            </Grid>
            <Grid item xs={8} sm={9} md={10}>
                <Grid container>
                    {search.queue === OrderQueues.Dashboard && <Dashboard />}
                    {search.queue !== OrderQueues.Dashboard &&
                        <>
                            <Grid item xs={12}>
                                <Filters />
                            </Grid>
                            <Grid item xs={12}>
                                <Results />
                            </Grid>
                        </>
                    }
                </Grid>
            </Grid>
        </Grid>
    );
}

export default Orders;